import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vueQr from 'vue-qr'
import { fetchGet,fetchPost} from '@/assets/js/http.js';
Vue.prototype.fetchGet = fetchGet
Vue.prototype.fetchPost = fetchPost
// Vue.prototype.website = window.location.origin+window.location.pathname;
Vue.prototype.website = window.location.origin+'/';

Vue.config.productionTip = false
//全局自定义组件
import HeaderPC from "./components/header";
Vue.component("HeaderPC", HeaderPC);
import FooterPC from "./components/footer";
Vue.component("FooterPC", FooterPC);
import mobileHeader from "./components/mobileHeader";
Vue.component("mobileHeader", mobileHeader);
Vue.component("vue-qr", vueQr);
// 全局样式文件
import './assets/main.css'
// rem.js
import './assets/js/rem.js'
// 判断页面打开平台
function _isMobile() {
	let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	return flag;
}
// 如果不是ent域名就跳转到ent域名里
var hostname=window.location.host;
var href=window.location.href;
// if(hostname!="ent.hp-soft.com"){
// 	href=href.replace(hostname, 'ent.hp-soft.com');
// 	href=href.replace('/ent/', '');
// 	window.location.href=href;
// }
// 路由守卫
router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title
	}
	console.log(to)
	// 统计代码
	// var hp_uid = '';
	// var lanmu = '大客户打印产品资料“一点通”';
	// var zilanmu = '';
	// var jieguo = '';
	// var goodssn = '';
	// var video = '';
	if(_isMobile()){
		if(to.fullPath.indexOf("/mobile")==-1){
			next({ path: '/mobile'+to.fullPath })
			return false;
		}
		// var coh = 2;
	}else{
		if(to.fullPath.indexOf("/mobile")!=-1){
			var reg = new RegExp("/mobile"); // 不加'g'，仅删除字符串里第一个"a"
			var fullPath = to.fullPath.replace(reg,"");
			next({ path: fullPath })
			return false;
		}
		// var coh = 1;
	}
	// var _paq = window._paq = window._paq || [];
	// /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
	// _paq.push(['trackPageView']);
	// _paq.push(['enableLinkTracking']);
	// (function() {
	// 	var u="//hptj2.wordhuo.com/";
	// 	_paq.push(['setTrackerUrl', u+'matomo.php?hp_uid='+hp_uid+'&goodssn='+goodssn+'&lanmu='+lanmu+'&zilanmu='+zilanmu+'&jieguo='+jieguo+'&video='+video+'&coh='+coh]);
	// 	_paq.push(['setSiteId', '1']);
	// 	var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
	// 	g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
	// })();
	next()
})

new Vue({
	router,
  render: h => h(App),
}).$mount('#app')
